module.exports = __webpack_public_path__ + "img/Hand_31_05_04.9373d38b.png";